<template>
  <div cols="8" class="container-fluid mt-1">
    <div class="text-xs-center">
      <v-layout align-center justify-space-around row fill-height>
        <div class="item">
          <b-button
            class="calculate-btn2"
            variant="primary"
            v-b-toggle.fov-sidebar
            >Calculate Field of View by Format, Sensor, or Pixel Count
          </b-button>
        </div>
        <div class="item">
          <b-button
            class="calculate-btn2"
            variant="primary"
            v-b-toggle.filter-sidebar
            >Filter Lenses by Attributes
          </b-button>
        </div>
      </v-layout>
    </div>
    <b-sidebar
      id="filter-sidebar"
      title="Narrow Your Search"
      right="true"
      shadow
    >
      <template>
        <v-card flat color="transparent">
          <v-subheader>F# Filter</v-subheader>
          <v-row>
            <v-col class="px-4">
              <v-range-slider
                v-model="fnorange"
                :max="8.0"
                :min="1.0"
                step="0.1"
                dense
                class="align-center"
              >
                <template v-slot:prepend>
                  <v-text-field
                    :value="fnorange[0]"
                    class="mt-0 pt-0"
                    single-line
                    type="number"
                    style="width: 40px"
                    @change="$set(fnorange, 0, $event)"
                  ></v-text-field>
                </template>
                <template v-slot:append>
                  <v-text-field
                    :value="fnorange[1]"
                    class="mt-0 pt-0"
                    single-line
                    type="number"
                    style="width: 40px"
                    @change="$set(fnorange, 1, $event)"
                  ></v-text-field>
                </template>
              </v-range-slider>
            </v-col>
          </v-row>
        </v-card>
      </template>
      <template>
        <v-card flat color="transparent">
          <v-subheader>Total Track Length (TTL) Filter</v-subheader>
          <v-row>
            <v-col class="px-4">
              <v-range-slider
                v-model="ttlrange"
                :max="55.0"
                :min="5"
                step="1"
                dense
                class="align-center"
              >
                <template v-slot:prepend>
                  <v-text-field
                    :value="ttlrange[0]"
                    class="mt-0 pt-0"
                    single-line
                    type="number"
                    style="width: 40px"
                    @change="$set(ttlrange, 0, $event)"
                  ></v-text-field>
                </template>
                <template v-slot:append>
                  <v-text-field
                    :value="ttlrange[1]"
                    class="mt-0 pt-0"
                    single-line
                    type="number"
                    style="width: 40px"
                    @change="$set(ttlrange, 1, $event)"
                  ></v-text-field>
                </template>
              </v-range-slider>
            </v-col>
          </v-row>
        </v-card>
      </template>
      <v-card flat color="transparent">
        <v-col class="px-4">
          <v-checkbox
            v-model="lowdistfilter"
            label="Low Distortion Lenses Only"
            color="success darken-2"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="constrfilter"
            label="All-Glass Lenses Only"
            color="success darken-2"
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="ipfilter"
            label="Ingress Protected Lenses Only"
            color="success darken-2"
            hide-details
          ></v-checkbox>
        </v-col>
        <v-row
          ><v-col class="px-4 py-4">
            <b-button
              class="calculate-btn2"
              variant="primary"
              @click="resetfilters()"
              >Reset Filters
            </b-button>
          </v-col>
          <v-col class="px-4 py-4">
            <b-button
              class="calculate-btn2"
              variant="primary"
              @click="applyfilter()"
              >Apply Filters
            </b-button>
          </v-col>
        </v-row>
        <v-col class="px-4 py-4">
          <p>
            Trying to filter a different way not shown above? Let us know what
            filters you'd like added: engineering@commonlands.com.
          </p>
        </v-col>
      </v-card>
    </b-sidebar>

    <b-sidebar
      id="fov-sidebar"
      title="Calculate Field of View and Angular Resolution"
      right="true"
      shadow
    >
      <div class="px-3 py-2">
        <p>
          Update the table with field of view values provided by our lenses on
          any sensor. Distortion included!
        </p>
        <b-row align-v="left">
          <p class="papp" style="font-size: 14px">
            Calculate FoV by Sensor Part Number
          </p>
          <b-form-select
            v-model="selected"
            :options="sensors"
            @change="
              selectSensor(
                sensors.filter((sensors) => sensors.value == selected)
              );
              calcFoV();
            "
            class="mb-1"
          >
          </b-form-select>
          <p class="papp" style="font-size: 14px">
            Calculate FoV by
            <a
              href="https://commonlands.com/blogs/technical/cmos-sensor-size"
              target="_blank"
              style="color: #08874a"
              rel="noopener"
              >Format</a
            >
          </p>
          <b-form-select
            v-model="selected"
            :options="options"
            @change="
              selectFormat();
              calcFoV();
            "
            class="mb-1"
          >
          </b-form-select>
          <b-col>
            <p class="papp" style="font-size: 14px">
              Calculate FoV by Pixel Count
            </p>
            <b-form-group :state="inputGroupState">
              <b-row>
                <b-form-input
                  id="hpix"
                  type="number"
                  required
                  v-model="sensor.hpix"
                  placeholder="# HPixels"
                ></b-form-input>
              </b-row>
              <b-row>
                <b-form-input
                  id="vpix"
                  type="number"
                  required
                  v-model="sensor.vpix"
                  placeholder="# VPixels"
                ></b-form-input>
              </b-row>
              <b-row>
                <b-form-input
                  id="pixpitch"
                  type="number"
                  required
                  v-model="sensor.pixpitch"
                  placeholder="Pixel Pitch(μm)"
                ></b-form-input>
              </b-row>
              <b-button
                block
                :disabled="inputGroupState"
                variant="primary"
                @click="
                  calcSensorSize();
                  calcFoV();
                "
                class="calculate-btn"
                >Calculate FoV</b-button
              >
            </b-form-group>
          </b-col>
        </b-row>
        Use exact sensor output mode details ("by pixel count") for the best results.
        <br /><br />
        <p>
          Angular resolution only shows if using the Calculate by Sensor PN or Calculate by Pixel Count as the calculation requires pixel pitch.
        </p>
      </div>
    </b-sidebar>

    <v-container>
      <v-layout align-center justify-space-around row fill-height>
        <div class="item">
          <p class="papp" style="font-size: 14px">
            Field of view and angular resolution for {{this.sensor.name}} a sensor {{this.sensor.hpixtext}} {{this.sensor.vpixtext}} with
            {{ this.sensor.hsize }}mm horizontal, {{ this.sensor.vsize }}mm
            vertical, {{ this.sensor.dsize }}mm diagonal, {{ this.sensor.pixpitch }}µm pixel pitch.
          </p>
        </div>
      </v-layout>
    </v-container>
    <b-table
      hover
      id="lensList"
      :items="lenses"
      :filter="selected"
      :filter-function="filteredTable"
      :fields="visibleFields"
      :bordered="true"
      :per-page="15"
      :current-page="currentPage"
      :small="true"
      :sort-by="sortKey"
      sort-icon-left
      label-sort-asc
      label-sort-desc
      label-sort-clear
      responsive
      selectable
      sticky-header="600px"
      caption-top
      @row-dblclicked="openUrl"
      @filtered="onFiltered"
    >
      <template #cell(hfov)="data"
        >{{ data.item.hfov }}° {{ data.item.hfovFisheye }}</template
      >
      <template #cell(vfov)="data"
        >{{ data.item.vfov }}° {{ data.item.vfovFisheye }}</template
      >
      <template #cell(dfov)="data"
        >{{ data.item.dfov }}° {{ data.item.dfovFisheye }}</template
      >
      <template #cell(vangularRes)="data"
        >{{ data.item.vangularRes }}px/°</template
      >
      <template #cell(hangularRes)="data"
        >{{ data.item.hangularRes }}px/°</template
      >
      <template #cell(cangularRes)="data"
        >{{ data.item.cangularRes }}px/°</template
      >
      <template #cell(efl)="data">{{ data.item.efl }}mm</template>
      <template #cell(max_fov)="data">{{ data.item.max_fov }}°</template>
      <template #cell(ttl)="data">{{ data.item.ttl }}mm</template>
      <template #cell(image_circle)="data"
        >{{ data.item.image_circle }}mm</template
      >
      <template #cell(PartNum)="data">
        {{ data.item.PartNum }}
        <b-button
          :href="data.item.url"
          target="_blank"
          size="sm"
          variant="outline-success"
        >
          <b-icon icon="box-arrow-up-right" scale="0.6"> </b-icon>
        </b-button>
      </template>
    </b-table>
    <div class="tableControls">
      <div class="tableCenter" align="center">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="15"
          prev-text="Prev"
          next-text="Next"
          align="center"
          aria-controls="lensList"
        >
        </b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import { listLensLists, listSensorData } from "../graphql/queries";

export default {
  name: "Home",
  data() {
    return {
      event: {},
      lenses: [],
      sensors: [],
      sensor: { hsize: 0, vsize: 0, dsize: 0, mpix: 0 },
      perPage: 14,
      currentPage: 1,
      totalRows: 1,
      selected: [1],
      sortKey: "efl",
      fnorange: [1.0, 8.0],
      ttlrange: [5.0, 55.0],
      lowdistfilter: false,
      ipfilter: false,
      constrfilter: false,
      options: [
        { value: [1], text: "All Format Types" },
        { value: [16.0], text: '1"' },
        { value: [12.0], text: '2/3"' },
        { value: [10.0], text: '1/1.6"' },
        { value: [9.2], text: '1/1.7"' },
        { value: [8.8], text: '1/1.8"' },
        { value: [8.4], text: '1/1.9"' },
        { value: [8.0], text: '1/2"' },
        { value: [7.85], text: '1/2.3"' },
        { value: [7.2], text: '1/2.5"' },
        { value: [6.7], text: '1/2.7"' },
        { value: [6.4], text: '1/2.8"'},
        { value: [6.0], text: '1/3"' },
        { value: [5.6], text: '1/3.2"' },
        { value: [5.3], text: '1/3.4"' },
        { value: [5.0], text: '1/3.6"' },
        { value: [4.5], text: '1/4"' },
      ],
      fields: [
        {
          key: "PartNum",
          sortable: true,
          stickyColumn: true,
          label: "Product",
          visible: true,
          tdClass: "tablePn",
        },
        {
          key: "efl",
          sortable: true,
          label: "EFL",
          visible: true,
        },
        { key: "f_num", sortable: true, label: "F#", visible: true },
        { key: "resolution", sortable: true, visible: true },
        {
          key: "lens_type",
          sortable: true,
          visible: true,
          tdClass: "tableLensType",
        },
        {
          key: "max_fov",
          sortable: true,
          label: "Max. FoV",
          visible: true,
        },
        {
          key: "hfov",
          sortable: true,
          label: "HFoV",
          visible: false,
          tdClass: "hFisheye",
        },
        {
          key: "vfov",
          sortable: true,
          label: "VFoV",
          visible: false,
          tdClass: "vFisheye",
        },
        {
          key: "dfov",
          sortable: true,
          label: "DFoV",
          visible: false,
          tdClass: "dFisheye",
        },
        {
          key: "hfovFisheye",
          label: "HFoV",
          visible: false,
          tdClass: "hFisheye",
        },
        {
          key: "vfovFisheye",
          label: "VFoV",
          visible: false,
          tdClass: "vFisheye",
        },
        {
          key: "dfovFisheye",
          label: "DFoV",
          visible: false,
          tdClass: "vFisheye",
        },
        {
          key: "distortion",
          label: "Distortion",
          sortable: true,
          visible: true,
        },
        {
          key: "cangularRes",
          label: "Ang.Res. Center",
          sortable: true,
          visible: false,
          tdClass: "angularRes",
        },
        {
          key: "vangularRes",
          label: "Ang.Res. Vedge",
          sortable: true,
          visible: false,
          tdClass: "angularRes",
        },
        {
          key: "hangularRes",
          label: "Ang.Res. Hedge",
          sortable: true,
          visible: false,
          tdClass: "angularRes",
        },
        {
          key: "image_circle",
          label: "Max Im.Cir",
          sortable: true,
          visible: true,
        },
        { key: "ttl", sortable: true, label: "Length (TTL)", visible: true },
        {
          key: "ingress",
          sortable: true,
          label: "IP-rating",
          visible: true,
          tdClass: "ipCss",
        },
        {
          key: "constr",
          sortable: true,
          label: "Optical Constr.",
          visible: true,
        },
      ],
    };
  },
  created() {
    this.getSensors();
    this.getData();
  },
  methods: {
    async getData() {
      const { data } = await API.graphql(graphqlOperation(listLensLists, { limit: 500, nextToken: null }));
      data.listLensLists.items.forEach((item) => {
        item.hfov = 0; //inject initial values
        item.vfov = 0;
        item.dfov = 0;
        item.hfovFisheye = "";
        item.vfovFisheye = "";
        item.dfovFisheye = "";
        item.cangularRes=0;
        item.vangularRes=0;
        item.hangularRes=0;
        if(item.lens_type!=="C FA"){
        this.lenses.push(item);
      }
      });
    },
    async postData(event) {
        // const apiName = process.env.VUE_APP_LENSES_API_NAME;
        const path = process.env.VUE_APP_LENSES_API_URL;
        const myInit = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(event)
        };

        try {
          const response = await fetch(path, myInit);
          if (response.ok) {
            const data = await response.json();
            // Process the response data
            return JSON.parse(data.body)
          } else {
            throw new Error('Request failed');
          }
        } catch (error) {
          console.error(error);
        }
        },

    async getSensors() {
      const { data } = await API.graphql(graphqlOperation(listSensorData,{ limit: 500, nextToken: null }));
      data.listSensorData.items.forEach((item) => {
        item.text = item.sensormfg + " " + item.id + " ("+ item.sensorhpix+"px*"+item.sensorvpix+"px,"+item.sensorpitch+"µm)";
        item.value = item.id;
        item.diagonal=5*item.sensorhpix*item.sensorpitch/4;
        if (item.diagonal<11000){
        this.sensors.push(item);
        }
      });
      
      this.sensors.sort((a, b) => {
         let aValue = a.sensormfg.toLowerCase(); 
         let bValue = b.sensormfg.toLowerCase();
          if (aValue !== bValue) { 
            return aValue > bValue ? 1 : -1;
           } else {
               aValue = a.id.toLowerCase();
               bValue = b.id.toLowerCase();
               return aValue > bValue ? 1 : -1; 
              } 
            });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    resetfilters() {
      (this.fnorange = [1.0, 8.0]),
        (this.ttlrange = [5.0, 55.0]),
        (this.lowdistfilter = false),
        (this.ipfilter = false),
        (this.constrfilter = false),
        (this.fnofilter = [1.0, 8.0]),
        (this.ttlfilter = [1.0, 8.0]);
    },
    filteredTable(row, filter) {
      //
      //let compare = filter;
      this.currentPage = 1;
      let fnomin = this.fnorange[0];
      let fnomax = this.fnorange[1];
      let ttlmin = this.ttlrange[0];
      let ttlmax = this.ttlrange[1];
      let rowingress = row.ingress;
      let rowconstr = row.constr;
      let rowdist = row.distortion;
      //Flag all lenses with f-theta distortion (this isn't perfect and includes stereographic)
      let fthetadist = false;

      let lType = row.lens_type;
      let compare = filter;
      const mpix = this.sensor.mpix * 0.6;
      const lensmegapixel = row.resolution;
      var megapixel = Number(lensmegapixel.match(/\d+/g));

      if (rowdist.includes("F")) {
        fthetadist = true;
      } else {
        fthetadist = false;
      }
      
      if (this.constrfilter && rowconstr == "Glass+Plastic") {
        return false;
      } else {
        if (this.ipfilter && rowingress == "/") {
          return false;
        } else {
          if (this.lowdistfilter && fthetadist) {
            return false;
          } else {
            if (row.f_num >= fnomin && row.f_num <= fnomax) {
              if (row.ttl >= ttlmin && row.ttl <= ttlmax) {
                if (row.image_circle >= compare && megapixel > mpix) {
                    return true;
                  } else {
                    if (
                      lType == "Fisheye" &&
                      row.image_circle >= filter * 0.52 &&
                      megapixel * 0.8 > mpix
                    ) {
                      return true;
                    }
                  };
              } else {
                return false;
              }
            } else {
              return false;
            }
          }
        }
      }
    },
    applyfilter() {
      this.$root.$emit("bv::toggle::collapse", "filter-sidebar");
    },
    openUrl(row) {
      let openedURL = row;
      window.open(openedURL.url, "_blank");
    },
    selectFormat() {
      const dsize = this.selected;
      const hsize = dsize / 1.25;
      const vsize = dsize / 1.67;

      this.sensor.hsize = Math.round(100 * hsize) / 100;
      this.sensor.vsize = Math.round(100 * vsize) / 100;
      this.sensor.dsize = Math.round(100 * dsize) / 100;
      this.sensor.pixpitch=0;
      this.sensor.mpix = 0;
    },
    selectSensor(sensorsPass) {
      sensorsPass = sensorsPass.shift();
      const sensorNum = sensorsPass;

      const hsize = (sensorNum.sensorhpix * sensorNum.sensorpitch) / 1000;
      const vsize = (sensorNum.sensorvpix * sensorNum.sensorpitch) / 1000;
      const dsize = Math.sqrt(hsize * hsize + vsize * vsize);
      this.sensor.mpix =
        Math.round(
          (10 * sensorNum.sensorhpix * sensorNum.sensorvpix) / 1000000
        ) / 10;

      this.sensor.hsize = Math.round(100 * hsize) / 100;
      this.sensor.vsize = Math.round(100 * vsize) / 100;
      this.sensor.dsize = Math.round(100 * dsize) / 100;
      this.sensor.pixpitch = sensorNum.sensorpitch;
      this.sensor.name=sensorNum.id;
      this.sensor.hpixtext= " in " + sensorNum.sensorhpix + "px *";
      this.sensor.vpixtext= sensorNum.sensorvpix + "px output";
      this.selected = this.sensor.dsize;
    },
    calcSensorSize() {
      const { hpix, vpix, pixpitch } = this.sensor;
      this.sensor.hsize = Math.round((100 * (hpix * pixpitch)) / 1000) / 100;
      this.sensor.vsize = Math.round((100 * (vpix * pixpitch)) / 1000) / 100;
      this.sensor.mpix = Math.round((10 * hpix * vpix) / 1000000) / 10;
      this.selected = Math.round(
        100 *
          Math.sqrt(
            this.sensor.hsize * this.sensor.hsize +
              this.sensor.vsize * this.sensor.vsize
          )
      ) / 100;
      this.sensor.name="";
      this.sensor.hpixtext= " in " + hpix + "px *";
      this.sensor.vpixtext= vpix + "px output";
      this.sensor.dsize = this.selected; //Update Table Lens Filter V-model
    },
    async calcFoV() {
      const hsize = this.sensor.hsize;
      const vsize = this.sensor.vsize;
      const dsize = this.sensor.dsize;
      const pixpitch = this.sensor.pixpitch;
      console.log(pixpitch)

      this.fields.label = hsize;
      this.currentPage = 1; //reset pagination to pg1.
      this.$root.$emit("bv::toggle::collapse", "fov-sidebar");

      //hide Max FoV column. Then show HFoV, VFoV, DFoV columns
      this.fields.forEach((toggle) => {
        if (dsize != 1) {
          if (toggle.key == "max_fov") {
            toggle.visible = false;
          } else {
            if (
              toggle.key == "dfov" ||
              toggle.key == "hfov" ||
              toggle.key == "vfov"
            ) {
              toggle.visible = true;
            }
          }
        } 
        if (pixpitch==0){
          if( 
            toggle.key=="cangularRes"||
            //toggle.key=="vangularRes"||
            toggle.key=="hangularRes"
          ){
            toggle.visible=false
          }
        } else {
          if( 
            toggle.key=="cangularRes"||
           // toggle.key=="vangularRes"||
            toggle.key=="hangularRes"
            ){
            toggle.visible=true
          }
        }
      }),
       // TODO: WRITE DOWN LAMBDA LOGIC HERE
        this.event = {
          lenses: this.lenses,
          sensors:  {
             hsize: hsize,
             vsize: vsize,
             dsize: dsize,
             pixpitch: pixpitch
          }
        }
        const result = await  this.postData(this.event)
        
        this.lenses = result;
    },
  },
  computed: {
   
    visibleFields() {
      return this.fields.filter((field) => field.visible);
    },
    showAlert() {
      return this.name.length > 4 ? true : false;
    },
    rows() {
      return this.lenses.length;
    },

    inputGroupState() {
      if (
        this.sensor.hpix > 0 &&
        this.sensor.vpix > 0 &&
        this.sensor.pixpitch > 0 &&
        this.sensor.hpix < 10000 &&
        this.sensor.vpix < 10000 &&
        this.sensor.pixpitch < 20
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>